/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Export_Video_TitleInputs */

const en_file_export_video_title = /** @type {(inputs: File_Export_Video_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video File`)
};

const fr_file_export_video_title = /** @type {(inputs: File_Export_Video_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fichier video`)
};

const de_file_export_video_title = /** @type {(inputs: File_Export_Video_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Videodatei`)
};

const it_file_export_video_title = /** @type {(inputs: File_Export_Video_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File video`)
};

const ru_file_export_video_title = /** @type {(inputs: File_Export_Video_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Видеофайл`)
};

const es_file_export_video_title = /** @type {(inputs: File_Export_Video_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archivo de vídeo`)
};

const zh_cn2_file_export_video_title = /** @type {(inputs: File_Export_Video_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`视频文件`)
};

const ja_file_export_video_title = /** @type {(inputs: File_Export_Video_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ビデオファイル`)
};

const hi_file_export_video_title = /** @type {(inputs: File_Export_Video_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वीडियो फाइल`)
};

const pt_pt2_file_export_video_title = /** @type {(inputs: File_Export_Video_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arquivo de vídeo`)
};

/**
* | output |
* | --- |
* | "Video File" |
*
* @param {File_Export_Video_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_export_video_title = /** @type {((inputs?: File_Export_Video_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Export_Video_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_file_export_video_title(inputs)
	if (locale === "de") return de_file_export_video_title(inputs)
	if (locale === "it") return it_file_export_video_title(inputs)
	if (locale === "ru") return ru_file_export_video_title(inputs)
	if (locale === "es") return es_file_export_video_title(inputs)
	if (locale === "zh-CN") return zh_cn2_file_export_video_title(inputs)
	if (locale === "ja") return ja_file_export_video_title(inputs)
	if (locale === "hi") return hi_file_export_video_title(inputs)
	if (locale === "pt-PT") return pt_pt2_file_export_video_title(inputs)
	return en_file_export_video_title(inputs)
});